import { useDispatch } from "react-redux";
import { default as clientIdService } from "../services/clientId";
import { defineToken } from "../utils/token";
import { AxiosError } from "axios";
import { useNavigate, useSearchParams } from "react-router";
import { ClientIDLoginParam } from "../types/clientId";
import { loginFailure, loginRequest, loginSuccess } from "../actions";
import useContractation from "@/components/Contractation/hooks/useContractation";
import { useTranslation } from "react-i18next";
import cookiesUtils from "@/utils/cookies";
import useLangs from "@/languages/hooks/useLangs";

const useClientId = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { firstContractationPath } = useContractation();
  const { t } = useTranslation();
  const { changeLang, getBCP47Lang } = useLangs();

  const removeSearchParams = () => {
    searchParams.delete("id_client");
    searchParams.delete("secret");

    // Route must be /connect or this won't work
    searchParams.set("waiting", "true");
    
    setSearchParams(searchParams);
  }

  const loginClientId = ({clientId, secret}: ClientIDLoginParam) => {
    removeSearchParams();
    cookiesUtils.acceptConsentCookies();
    dispatch(loginRequest('AXIONAL'));
    clientIdService.login({clientId, secret})
    .then(({token}) => {
      if (token) {
        const { locale, new_customer } = defineToken(token);
        if (locale) {
          changeLang(getBCP47Lang(locale));
        }
        dispatch(loginSuccess({newCustomer: new_customer}));
        firstContractationPath && navigate(t(firstContractationPath));
      } else {
        dispatch(loginFailure({statusCode: 505, status: "error"}));
      }
    })
    .catch((error: AxiosError) => {
      dispatch(loginFailure({statusCode: 505, status: "error"}));
    });
  };

  return {
    loginClientId
  }
};

export default useClientId;
